import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.267 512 512 0 01950.613 248.32a508.16 508.16 0 0158.027 387.413A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-117.76 958.293A486.4 486.4 0 00983.893 629.76 486.4 486.4 0 00629.76 40.107 488.96 488.96 0 00512 25.6zM630.613 768l-102.4-204.8h-92.16V768H362.24V281.6h188.587a139.093 139.093 0 01151.04 142.08 128 128 0 01-96.854 128L716.8 765.013zM545.28 348.16H436.053v152.32H545.28a73.813 73.813 0 0082.773-75.947 74.667 74.667 0 00-82.773-76.373z"
});

function SvgZar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ZAR_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZar);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'ZAROutlined';

export default KuFoxIcons;
